import { render, staticRenderFns } from "./UserEditScore.vue?vue&type=template&id=62accc2e&"
import script from "./UserEditScore.vue?vue&type=script&lang=js&"
export * from "./UserEditScore.vue?vue&type=script&lang=js&"
import style0 from "./UserEditScore.vue?vue&type=style&index=0&id=62accc2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports